'use strict'

import ajax from '@/plugin/ajax.js'

const queryGroup = function (pageIndex, pageSize, sortOrder, sortField, fastSearchFields, fastSearchKeyWord) {
    return ajax.post('/Sys/Groups/Query', {
        pageSize: pageSize,
        pageIndex: pageIndex,
        sortOrder: sortOrder,
        sortField: sortField,
        fastSearchFields: fastSearchFields,
        fastSearchKeyWord: fastSearchKeyWord
    })
}
const deleteGroup = function (Id) {
    return ajax.post('/Sys/Groups/Delete', { Id: Id })
}
const saveGroup = function (model) {
    return ajax.post('/Sys/Groups/Save', model)
}

const loadGroupMemberData = function (groupId,
    pageIndex,
    pageSize,
    sortOrder,
    fastSearchFields,
    fastSearchKeyWord,
    sortField) {
    return ajax.post('/Sys/Groups/LoadGroupMemberData', {
        groupId: groupId,
        pageSize: pageSize,
        pageIndex: pageIndex,
        sortOrder: sortOrder,
        fastSearchFields: fastSearchFields,
        fastSearchKeyWord: fastSearchKeyWord,
        sortField: sortField
    });
}
const deleteGroupMember = function (id) {
    return ajax.post('/Sys/Groups/DeleteGroupMember', { Id: id });
}
const saveGroupMember = function (items, roleId) {
    return ajax.post('/Sys/Groups/SaveGroupMember', { items: items, groupId: roleId })
}
export { queryGroup, deleteGroup, saveGroup, loadGroupMemberData, deleteGroupMember, saveGroupMember }

